import getQueryParams from 'shared/utils/get-query-params';

export const parseExperimentsFromUrl = ({ url }) => {
  const queryParams = getQueryParams(url);

  const { experiments = '' } = queryParams;
  return _.reduce(
    experiments.split(','),
    function(acc, name) {
      if (name) {
        return { ...acc, [name]: 'true' };
      }
      return acc;
    },
    {},
  );
};
